const imageSetObject = {
  "construction" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/1_30bac1ef-f158-4b66-89ae-be31df0bd9ed.png?v=1735980927",
  "boot_width" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/7_90e9b657-30c1-46a0-81b6-60fe7a6ef2eb.png?v=1735980925",
  "midsole" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/2_46ea64d9-3f4c-41c9-b7d1-8f753901a5e1.png?v=1735980926",
  "insole" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/3_290789e4-da66-4d0e-84fe-d4524381fbe0.png?v=1735980926",
  "outsole" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/5_ae9480ac-1821-4619-b9f9-14689b0784b9.png?v=1735980928",
  "kiltie" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/6_b89b354a-81fd-4255-a7ce-23a496089633.png?v=1735980927",
  "speedhooks" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/4_c1f816aa-d5e9-4afe-b3c5-c4fe77776b79.png?v=1735980927",
} 

const observeYmqBox = () => {
  return new Promise((resolve, reject) => {
    const observer = new MutationObserver(() => {
      const ymqBox = document.querySelector('.gpo-container');
      if (ymqBox) { observer.disconnect(); resolve(ymqBox); }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      reject(new Error("Timed out waiting for 'ymqBox'"));
    }, 10000);
  });
};

const observeRequiredCheckbox = () => {
  return new Promise((resolve, reject) => {
    const observer = new MutationObserver(() => {
      const requiredBox = document.getElementById('terms_condition');
      if (requiredBox) { observer.disconnect(); resolve(requiredBox); }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      reject(new Error("Timed out waiting for 'requiredBox'"));
    }, 5000);
  });
}

const observeHelpBox = () => {
  return new Promise((resolve, reject) => {
    const observer = new MutationObserver(() => {
      const helpBox = document.querySelector('.custom_option_tool_tip'); // Fixed selector (missing '.' for class)
      if (helpBox) {
        observer.disconnect();
        resolve(helpBox);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Timeout to stop observation after 5 seconds if the element isn't found
    setTimeout(() => {
      observer.disconnect();
      reject(new Error("Timed out waiting for 'helpBox'"));
    }, 5000);
  });
};

const enableHelp = async () => {
  try {
    // Wait for the element to appear
    const hlpBox = await observeHelpBox();

    // Query all help boxes
    const helpBoxes = document.querySelectorAll('.custom_option_tool_tip');
    const popupState = document.querySelector('.document_overlay');
    const closePopup = document.querySelector('.close_icon');
    const imageElement = document.getElementById('variableImage');

    console.log('Observed helpBox:', hlpBox);

    // Attach click event listeners to all help boxes
    if (helpBoxes.length > 0) {
      helpBoxes.forEach((helpBox) => {
        helpBox.addEventListener('click', () => {
          const helpForOption = helpBox.getAttribute('data-help');

          // Ensure the imageSetObject exists and the key is valid
          if (helpForOption && imageSetObject[helpForOption]) {
            imageElement.setAttribute('src', imageSetObject[helpForOption]);
            popupState.classList.add('show');
          } else {
            console.error(`No matching image found for data-help: ${helpForOption}`);
          }
        });
      });
    }

    // Handle closing the popup
    if (closePopup) {
      closePopup.addEventListener('click', () => {
        popupState.classList.remove('show');
      });
    } else {
      console.error('Close icon not found');
    }
  } catch (e) {
    console.error(e.message);
  }
};


const initVariantTab = async () => {
  try {
    const ymqBox = await observeYmqBox();

    const requiredCheckbox = await observeRequiredCheckbox();
    
    const tab = '<div id="variantTab" class="variant-tab">Customize your product <span class="status">&#10095;</span></div>';
    ymqBox.insertAdjacentHTML('beforebegin', tab);
    
    document.getElementById('variantTab').addEventListener('click', () => {
      ymqBox.classList.toggle('show');
    });

    const tnc = document.querySelector(".required_checkbox_tnc");
    
    const popupState = document.querySelector('.document_overlay');
    
    const closePopup = document.querySelector('.close_icon')
  
    if (tnc) {
       // Insert `tnc` after `ymqBox`
       ymqBox.insertAdjacentElement("afterend", tnc);

      requiredCheckbox.addEventListener('change', (e) => {
        if(e.target.checked) {
          document.querySelector('.fakeButtonOverlay .fakeButton').classList.add('remove');
        } else {
          document.querySelector('.fakeButtonOverlay .fakeButton').classList.remove('remove');
        }
      })
    }

    document.querySelector('.fakeButtonOverlay .fakeButton').addEventListener('click', () => {
      tnc.classList.add('show_error')
    })

    const helpBoxes = document.querySelectorAll('.custom_option_tool_tip');
    if (helpBoxes) {
      helpBoxes.forEach((helpBox) => {
        helpBox.addEventListener('click', () => {
          const helpForOption = helpBox.getAttribute('data-help');
          const imageElement = document.getElementById('variableImage');

          imageElement.setAttribute('src', imageSetObject[helpForOption])
          popupState.classList.add('show')
        });
      });
    }

    closePopup.addEventListener('click', () => {
      popupState.classList.remove('show')
    })
    
  } catch (error) {
    console.error(error.message);
  }
};

document.addEventListener("DOMContentLoaded", function(e) {
    initVariantTab();
    enableHelp();
  
	let a = document.querySelector.bind(document),
		d = document.querySelectorAll.bind(document);

	let c = d(".testimonials-slider");
	c.length && c.forEach(function(a) {
		new Swiper(a, {
			effect: "coverflow",
			grabCursor: !0,
			centeredSlides: !0,
			slidesPerView: 1,
			loop: !0,
			coverflowEffect: {
				rotate: 50,
				stretch: 0,
				depth: 100,
				modifier: 1,
				slideShadows: !0
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev"
			},
			pagination: {
				el: ".swiper-pagination"
			},
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				1024: {
					slidesPerView: 3
				}
			}
		})
	})


   function splitAttrString(theStr) {
        var attrs = [];

        var RefString = function (s) {
            this.value = s;
        };
        RefString.prototype.toString = function () {
            return this.value;
        };
        RefString.prototype.charAt = String.prototype.charAt;
        var data = new RefString(theStr);

        var getBlock = function (endChr, restString) {
            var block = '';
            var currChr = '';
            while ((currChr != endChr) && (restString.value !== '')) {
                if (/'|"/.test(currChr)) {
                    block = $.trim(block) + getBlock(currChr, restString);
                } else if (/\{/.test(currChr)) {
                    block = $.trim(block) + getBlock('}', restString);
                } else if (/\[/.test(currChr)) {
                    block = $.trim(block) + getBlock(']', restString);
                } else {
                    block += currChr;
                }
                currChr = restString.charAt(0);
                restString.value = restString.value.slice(1);
            }
            return $.trim(block);
        };

        do {
            var attr = getBlock(',', data);
            attrs.push(attr);
        }
        while (data.value !== '');
        return attrs;
    }

})